module.exports = __webpack_public_path__ + "static/img/ent-21.6f7eccf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-21.jpg
// module id = OQPG
// module chunks = 51